import React, { useState } from 'react';

const EventCalendarPage = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedEvent, setSelectedEvent] = useState(null);

  // Sample events data
  const events = [
    {
      id: 1,
      title: "Genel Güvenlik Eğitimi",
      date: "2025-07-30",
      time: "09:00",
      location: "Konferans Salonu A",
      type: "Eğitim",
      description: "Tüm çalışanlar için zorunlu güvenlik eğitimi",
      attendees: 150
    },
    {
      id: 2,
      title: "Proje Yönetimi Zirvesi",
      date: "2025-08-15",
      time: "14:00",
      location: "Toplantı Salonu B",
      type: "Toplantı",
      description: "Devam eden projelerin durumu ve planlama",
      attendees: 25
    },
    {
      id: 3,
      title: "Yıl Sonu Performans Değerlendirmesi",
      date: "2025-08-20",
      time: "10:00",
      location: "İK Departmanı",
      type: "Değerlendirme",
      description: "2025 yılı performans görüşmeleri",
      attendees: 500
    },
    {
      id: 4,
      title: "Yeni Teknoloji Semineri",
      date: "2025-09-05",
      time: "15:30",
      location: "AR-GE Merkezi",
      type: "Seminer",
      description: "İnşaat sektöründe dijital dönüşüm",
      attendees: 80
    }
  ];

  const monthNames = [
    "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
    "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
  ];

  const dayNames = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = (firstDay.getDay() + 6) % 7; // Monday = 0

    const days = [];
    
    // Empty cells for days from previous month
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(null);
    }
    
    // Days of current month
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(day);
    }
    
    return days;
  };

  const getEventsForDate = (day) => {
    if (!day) return [];
    const dateStr = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    return events.filter(event => event.date === dateStr);
  };

  const previousMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };

  const nextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };

  const getEventTypeColor = (type) => {
    const colors = {
      'Eğitim': 'bg-primary',
      'Toplantı': 'bg-success',
      'Değerlendirme': 'bg-warning',
      'Seminer': 'bg-info'
    };
    return colors[type] || 'bg-secondary';
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Calendar */}
        <div className="col-lg-8">
          <div className="box">
            <div className="box-header">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="card-title">Etkinlik Takvimi</h4>
                <div className="d-flex align-items-center">
                  <button className="btn btn-outline-primary btn-sm me-2" onClick={previousMonth}>
                    <i className="bx bx-chevron-left"></i>
                  </button>
                  <h5 className="mb-0 mx-3">
                    {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
                  </h5>
                  <button className="btn btn-outline-primary btn-sm" onClick={nextMonth}>
                    <i className="bx bx-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="box-body">
              <div className="calendar-grid">
                <div className="row">
                  {dayNames.map(day => (
                    <div key={day} className="col">
                      <div className="calendar-day-header text-center fw-bold py-2">
                        {day}
                      </div>
                    </div>
                  ))}
                </div>
                {Array.from({ length: Math.ceil(getDaysInMonth(currentDate).length / 7) }, (_, weekIndex) => (
                  <div key={weekIndex} className="row">
                    {getDaysInMonth(currentDate).slice(weekIndex * 7, (weekIndex + 1) * 7).map((day, dayIndex) => (
                      <div key={dayIndex} className="col p-0">
                        <div className={`calendar-day ${day ? 'active' : 'inactive'}`} style={{ minHeight: '100px', border: '1px solid #e9e9e9' }}>
                          {day && (
                            <>
                              <div className="day-number p-2 fw-bold">{day}</div>
                              <div className="day-events p-1">
                                {getEventsForDate(day).map(event => (
                                  <div
                                    key={event.id}
                                    className={`badge ${getEventTypeColor(event.type)} text-white mb-1 d-block text-start`}
                                    style={{ fontSize: '10px', cursor: 'pointer' }}
                                    onClick={() => setSelectedEvent(event)}
                                  >
                                    {event.time} - {event.title}
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Event Details & Upcoming Events */}
        <div className="col-lg-4">
          {/* Selected Event Details */}
          {selectedEvent && (
            <div className="box mb-4">
              <div className="box-header">
                <h5 className="card-title">Etkinlik Detayları</h5>
                <button 
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setSelectedEvent(null)}
                >
                  <i className="bx bx-x"></i>
                </button>
              </div>
              <div className="box-body">
                <h6 className="text-primary">{selectedEvent.title}</h6>
                <p className="mb-2">
                  <i className="bx bx-calendar me-2"></i>
                  {new Date(selectedEvent.date).toLocaleDateString('tr-TR')}
                </p>
                <p className="mb-2">
                  <i className="bx bx-time me-2"></i>
                  {selectedEvent.time}
                </p>
                <p className="mb-2">
                  <i className="bx bx-map me-2"></i>
                  {selectedEvent.location}
                </p>
                <p className="mb-2">
                  <i className="bx bx-group me-2"></i>
                  {selectedEvent.attendees} katılımcı
                </p>
                <p className="text-muted">{selectedEvent.description}</p>
                <div className="d-grid gap-2">
                  <button className="btn btn-primary btn-sm">
                    <i className="bx bx-calendar-plus me-1"></i>
                    Katıl
                  </button>
                  <button className="btn btn-outline-primary btn-sm">
                    <i className="bx bx-share me-1"></i>
                    Paylaş
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Upcoming Events */}
          <div className="box">
            <div className="box-header">
              <h5 className="card-title">Yaklaşan Etkinlikler</h5>
            </div>
            <div className="box-body">
              {events.slice(0, 4).map(event => (
                <div key={event.id} className="d-flex align-items-center mb-3 p-2 border rounded">
                  <div className={`badge ${getEventTypeColor(event.type)} me-3`}>
                    {event.type}
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-1">{event.title}</h6>
                    <small className="text-muted">
                      <i className="bx bx-calendar me-1"></i>
                      {new Date(event.date).toLocaleDateString('tr-TR')} - {event.time}
                    </small>
                  </div>
                  <button 
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => setSelectedEvent(event)}
                  >
                    <i className="bx bx-info-circle"></i>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCalendarPage; 